import { VueSelect } from '@ui-common/vue-select';

const UNKNOWN_FORM_ID = 'Unknown form id';
const UNKNOWN_FORM_ELEMENT_ID = 'Unknown form element id';
const SELECT_CHANGE_GTM_EVENT_NAME = 'dropDownSelect';

export default {
	extends: VueSelect,
	methods: {
		close() {
			if (this.dropdownVisible) {
				this.dropdownVisible = false;
				this.$nextTick(() => {
					this.$refs.button.focus();
				});
				this.$emit('input', this.selected);
				const FORM_ID = this.$refs.button && this.$refs.button.form && this.$refs.button.form.id ? this.$refs.button.form.id : UNKNOWN_FORM_ID;
				this.$gtm.trackEvent({
					event: SELECT_CHANGE_GTM_EVENT_NAME,
					formElementID: this.id || UNKNOWN_FORM_ELEMENT_ID,
					FORM_ID,
					inputValue: this.selectedText
				});
				this.$emit('list-opened', false);
			}
		}
	}
};
